<template>
  <PageWrapper
    :active-section="SECTION_EXPLORE"
    :active-page="PAGE_EXPLORE_FEEDS"
    align="left"
    width="full"
  >
    <iRow wrap="nowrap">
      <SmartFeed
        :pinia-store="useExploreFeedsFeedStore"
        default-smart-feed-layout="grid"
        default-entity-layout="cardSmall"
        load-more-behavior="auto"
      />
    </iRow>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { PAGE_EXPLORE_FEEDS, SECTION_EXPLORE } from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeed.vue";
import { useExploreFeedsFeedStore } from "@/smart-feed/stores/feed/explore-feeds-feed-store";
export default {
  name: "ExploreFeeds",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_EXPLORE,
      PAGE_EXPLORE_FEEDS,
    };
  },
  methods: { useExploreFeedsFeedStore },
};
</script>
